<script>
    import { TinyPumperStatus } from '@/enums/TinyPumper';
    import TinyPumperStatusCell from '@/components/tinyPumper/TinyPumperStatusCell';

    const TOOLTIPS = {
        [TinyPumperStatus.Good]: 'Both Gateway and Online statuses are Good, meaning everything is operating normally.',
        [TinyPumperStatus.Warning]:
            'At least one of the statuses is Warning, but neither is Critical or N/A. This means there is a minor issue that may require attention.',
        [TinyPumperStatus.Critical]:
            'If either the Gateway or Online status is Critical, the final status is Critical. This means there is a serious issue that needs immediate attention.',
        [TinyPumperStatus.NA]:
            'If either status is N/A, the final status is N/A. This means there is missing or unavailable data, making it impossible to determine the actual state.'
    };

    export default {
        name: 'TinyPumperHealthReportTotals',
        props: {
            // Aggregated by SQL Server, not derived from the grid: the fleet grid is paged now, and a
            // total over the twenty rows the browser happens to hold is not a total.
            totals: {
                type: Array,
                default: () => []
            }
        },
        components: {
            TinyPumperStatusCell
        },
        computed: {
            getTotals() {
                return (this.totals || []).map(total => ({
                    ...total,
                    tooltip: TOOLTIPS[total.status] || ''
                }));
            }
        }
    };
</script>

<template>
    <div class="row g-3">
        <div
            v-for="(total, index) in getTotals"
            :key="`card-status-totals-${index}`"
            class="col-sm-6 col-md-3 col-lg-2 col-xl-1"
            style="min-width: 15rem"
        >
            <div class="card card-body rounded-3">
                <div class="d-flex align-items-center" :title="total.tooltip">
                    <TinyPumperStatusCell :status="total.status" />
                    <div class="ms-auto fs-5 fw-bold">{{ total.count }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
